import List from 'components/List'
import Panel from 'components/Panel'

import FontAwesome from 'react-fontawesome'

const TrendingTopics = ({
  isFetching,
  faqs,
  tutorials,
  renderItemList,
  height
}) => {
  const icon = <FontAwesome name="signal" />

  return (
    <Panel title="Trending Topics" buttons={icon} blue height={height}>
      {!isFetching && (
        <>
          {tutorials.length !== 0 && (
            <List title="Tutorials:">
              {renderItemList(tutorials, { showDevice: true })}
            </List>
          )}

          {faqs.length !== 0 && (
            <List title="FAQs:">
              {renderItemList(faqs, { showDevice: true })}
            </List>
          )}
          {faqs.length === 0 && tutorials.length === 0 && (
            <div className="no-content">
              There are currently no trending topics
            </div>
          )}
        </>
      )}
    </Panel>
  )
}

export default TrendingTopics
